const api = {
  get baseURL() {
    if (__DEV__ && typeof window !== "undefined" && window.location.pathname.endsWith("/standalone.html")) {
      return "https://demo.2bitcloud.ch";
    }
    return localStorage.getItem("baseURL");
  },
  set baseURL(url) {
    localStorage.setItem("baseURL", url);
  },
  createLead: "/api/v1/outlook/crm.lead/call/create",
  searchLeads: "/api/v1/outlook/crm.lead/call/search_read",
  searchInvoices: "/api/v1/outlook/account.move/call/search_read",
  createInvoice: "/api/v1/outlook/account.move/call/create",
  searchSaleOrders: "/api/v1/outlook/sale.order/call/search_read",
  createSaleOrder: "/api/v1/outlook/sale.order/call/create",
  searchPurchaseOrders: "/api/v1/outlook/purchase.order/call/search_read",
  createPurchaseOrder: "/api/v1/outlook/purchase.order/call/create",
  deleteLead: "/mail_client_extension/lead/delete",
  getCompany: "/api/v1/outlook/res.company/{id}/call/read",
  getPartner: "/api/v1/outlook/res.partner/{id}/call/read",
  searchPartner: "/api/v1/outlook/res.partner/call/search_read",
  createPartner: "/api/v1/outlook/res.partner",
  createProject: "/api/v1/outlook/project.project/call/create",
  searchProject: "/api/v1/outlook/project.project/call/search_read",
  searchTasks: "/api/v1/outlook/project.task/call/search_read",
  createTask: "/api/v1/outlook/project.task/call/create",
  searchTickets: "/api/v1/outlook/helpdesk.ticket/call/search",
  readTicket: "/api/v1/outlook/helpdesk.ticket/{id}/call/read",
  createTicket: "/api/v1/outlook/helpdesk.ticket/call/create",
  getInstalledModules: "/mail_client_extension/modules/get",
  contactCreate: "/api/v1/outlook/res.partner",
  redirectCreateLead: "/mail_client_extension/lead/create_from_partner",
  iapLeadEnrichmentEmail: "https://iap-services.odoo.com/iap/clearbit/1/lead_enrichment_email",
  iapLeadEnrichment: "https://iap-services.odoo.com/iap/mail_extension/enrich",
  logSingleMail: "/api/v1/outlook/mail.message/call/create",
  logAttachment: "/api/v1/outlook/ir.attachment/call/create",


  // Authentication
  addInBaseURL: "https://" + __DOMAIN__,
  outlookScope: "outlook",
  outlookFriendlyName: "Outlook"
};

export default api;
